import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTimeCycle1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#time-cycle-1_svg__a)'>
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M17.5 7.5H20V5'
      />
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M19.794 7.5A9 9 0 0 0 7.5 4.206M13.147 19.013l-1.25 2.165 2.165 1.25M5.353 9.487l-1.25-2.165-2.165 1.25'
      />
      <path
        stroke='#fff'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M12 21a9 9 0 0 0 9-9M4.206 7.5A9 9 0 0 0 7.5 19.794M12 13V7M12 13l2.121 2.121'
      />
      <circle cx={12} cy={12} r={9} fill='#fff' opacity={0.2} />
    </g>
    <defs>
      <clipPath id='time-cycle-1_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgTimeCycle1)
export default ForwardRef
